import { HostListener, Component, Input, Output, OnInit, NgZone } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AngularFireAuth } from "@angular/fire/auth";
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from '../header/header.component';



@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.sass']
})


export class DefaultComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(event.target.innerWidth < 1100){
      this.sideBarOpen = false;
    }
    else{
      this.sideBarOpen = true;
    }
  }

  email: string;
  password: string;
  usersListSubs: Subscription;
  // usersList: UsersModule[];
  @Output() sideBarOpen = true;
  isLogged: Boolean = false;
  isLoaded: Boolean = false;


  constructor(
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private dataService: DataService,
    private headerComponent: HeaderComponent,
    private translate:TranslateService,

  ) { }

  // ngAfterViewer(){
  //   this.isLoaded = true;
  // }

  ngOnInit() {
    this.firebase.user.subscribe(user => {
        console.log(user?.isAnonymous)
        if (user?.isAnonymous || !user) {
          this.router.navigate(['/login']);
        }
        else{
          this.isLogged = true;
          this.dataService.getLang().subscribe(res => {
            this.translate.use(res.toString());
            // TODO insert here the control of superadmin, family and school 
            this.isLoaded = true;
            this.headerComponent.selectedLanguageFlag = res.toString()
          });
        }
    })
    if(window.innerWidth < 1100){
      this.sideBarOpen = false;
    }
    else{
      this.sideBarOpen = true;
    }
    
    
  }

  sideBarToggler(){
    this.sideBarOpen = !this.sideBarOpen;
  }

  sideBarClose(){
    if(window.innerWidth < 1100){
      this.sideBarOpen = false;
    }
    else{
      this.sideBarOpen = true;
    }
  }
  
}